import type { ClientPropertyVehicleDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { CAR_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/CarForm/carFormDefaults";
import type { CarFormInput } from "web_myplann/Portfolio/Forms/CarForm/carFormSchema";
import {
	parseIsoDate,
	parseMonthYear,
} from "web_myplann/Portfolio/Forms/dateParsers";

export const mapPropertyToCarForm = (
	property: ClientPropertyVehicleDetailResponseDTO,
): CarFormInput => ({
	carBrand: property.carBrand ?? DEFAULTS.carBrand,
	carModel: property.carModel ?? DEFAULTS.carModel,
	propertyType: property.propertyType ?? DEFAULTS.propertyType,
	carFuel: property.carFuel ?? DEFAULTS.carFuel,
	carLicensePlate: property.carLicensePlate ?? DEFAULTS.carLicensePlate,
	carVin: property.carVin ?? DEFAULTS.carVin,
	value: property.value ?? DEFAULTS.value,
	carPurchaseDate: parseIsoDate(property.carPurchaseDate),
	carRegistration: parseIsoDate(property.carRegistration),
	carManufactureMonthYear: parseMonthYear(property.carManufactureMonthYear),
	carPower: property.carPower ?? DEFAULTS.carPower,
	carVolume: property.carVolume ?? DEFAULTS.carVolume,
	description: property.description ?? DEFAULTS.description,
	forInvestments: property.forInvestments ?? DEFAULTS.forInvestments,
});
